import React from 'react';
import './index.scss';

export default function Actions({
  disabled,
  preferences,
  values,
  onPreferencesFormSubmit,
  onCancelClick,
  isSaving,
  saveError,
  actionIndex,
}) {
  return (
    <div className="preferences__content__action">
      <button
        type="submit"
        className="btn btn--primary btn--lg"
        disabled={disabled}
        onClick={(e) => {
          e.preventDefault();
          const finalValues = values || preferences;
          onPreferencesFormSubmit(preferences, finalValues, actionIndex);
        }}
      >
        {isSaving ? 'Saving...' : 'Save'}
      </button>
      <button
        className="btn btn--link button-cancel"
        onClick={(e) => {
          e.preventDefault();
          onCancelClick();
        }}
      >
        Cancel
      </button>

      {saveError && (
        <div className="save-error-message">
          <span className="error-text">{saveError}</span>
        </div>
      )}
    </div>
  );
}
